<template lang="pug">
el-container(style="height: 100vh" direction="vertical")

  el-main
    .registration

      .logo
        img(:src="images.logo")

      h1 {{ $t('password_reset.title03') }}
      p {{ $t('password_reset.description02') }}

      .send
        el-button
          a(href="/sign_in") {{ $t('password_reset.go_login') }}
  publicFooter
</template>

<script>
import Header from '../public/Header.vue'
import Footer from '../public/Footer.vue'
import API from '@/api/user'
export default {
  data () {
    return {
      images:{
        logo: require('@/assets/cuona_nolabel_logo.svg')
      }
    }
  },
  components: {
    'publicHeader': Header,
    'publicFooter': Footer
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.registration {
  width: 400px;
  background: #FFF;
  margin: 20px auto;
  padding: 30px;
  border-radius: 5px;
  border: 1px solid $border;

  .logo {
    margin: 0 auto 30px auto;
    width: 40%;
  }

  h1 {
    margin: 0 0 20px 0;
    font-size: 18px;
    font-weight: normal;
    text-align: center;
  }

  p {
    font-size: 13px;
    text-align: center;
    color: #999;
  }

  .send {
    margin-top: 30px;
    text-align: center;
  }
}

</style>

